import { UserManager } from "oidc-client-ts";
import type { AuthProviderProps } from "react-oidc-context";

/** Module-scoped so the Apollo links can reach it without a hook. */
export const userManager = new UserManager({
  authority: import.meta.env.VITE_OIDC_AUTHORITY,
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_OIDC_REDIRECT_URI,
  scope: "openid profile email roles",
});

export const authProviderProps: AuthProviderProps = {
  userManager,
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
